import React from 'react';
import { useConfirm } from 'material-ui-confirm';
import { useIntl } from 'react-intl';

import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import List from '@/components/mui/DropdownButton/components/List';

const DropdownButton = ({
  options,
  title: btnTitle,
  disabled,
  variant = 'contained',
  color = 'primary',
  BtnIcon,
  IconButtonProps = {},
  ButtonProps = {},
  iconButtonClassName,
  placement,
  popperModifiers,
}) => {
  const confirm = useConfirm();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const { formatMessage } = useIntl();

  const menuItemClick = (cb) => {
    cb();
    setOpen(false);
  };

  const handleMenuItemClick = (cb, confirmOptions) => {
    if (confirmOptions && !confirmOptions.isAutoConfirm) {
      confirm({ ...confirmOptions })
        .then(() => {
          menuItemClick(cb);
        })
        .catch(() => {});
    } else {
      menuItemClick(cb);
    }
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  return (
    <>
      {BtnIcon ? (
        <IconButton
          aria-label="more"
          onClick={handleToggle}
          disabled={disabled}
          size="small"
          ref={anchorRef}
          className={iconButtonClassName}
          color={color}
          {...IconButtonProps}
        >
          {BtnIcon}
        </IconButton>
      ) : (
        <Button
          onClick={handleToggle}
          variant={variant}
          color={color}
          disabled={disabled}
          size="small"
          ref={anchorRef}
          endIcon={<ArrowDropDownIcon />}
          {...ButtonProps}
        >
          {formatMessage(btnTitle)}
        </Button>
      )}
      <List
        options={options}
        handleMenuItemClick={handleMenuItemClick}
        formatMessage={formatMessage}
        handleClose={handleClose}
        anchorRef={anchorRef}
        open={open}
        placement={placement}
        popperModifiers={popperModifiers}
      />
    </>
  );
};

export default DropdownButton;
